export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20stylized%20artistic%20illustration%20of%20a%20young%20person%20deeply%20absorbed%20in%20reading%20colorful%20digital%20manga%20comics%20on%20a%20sleek%20modern%20tablet%20device%2C%20surrounded%20by%20floating%20semi%20transparent%20manga%20panel%20frames%20with%20dynamic%20action%20lines%20and%20Japanese%20Korean%20style%20speech%20bubbles%2C%20warm%20coral%20and%20soft%20cream%20gradient%20background%2C%20modern%20minimalist%20editorial%20illustration%20composition%20with%20soft%20diffused%20lighting%20and%20gentle%20atmospheric%20shadows%2C%20cozy%20intimate%20reading%20atmosphere%20representing%20Korean%20Japanese%20and%20Chinese%20comic%20culture%20digital%20reading%20experience%20with%20warm%20inviting%20aesthetic&width=1400&height=900&seq=hero-manga-2026&orientation=landscape"
          alt="汗汗漫画 - 在线漫画阅读体验"
          title="汗汗漫画在线漫画阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-4">
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-500/80 text-background-50 whitespace-nowrap">热门连载</span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500/80 text-background-50 whitespace-nowrap">每日更新</span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-secondary-500/80 text-background-50 whitespace-nowrap">全本免费</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-3">
              汗汗漫画 - 韩漫日漫国漫免费漫画全集
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 font-heading mb-6">
              下拉式连续阅读，在线看漫画流畅不卡顿
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              汗汗漫画网汇集韩国漫画、日本漫画、国产漫画等主流类型，覆盖恋爱、热血、悬疑、奇幻等海量分类。
              采用下拉式连续阅读模式，无需翻页即可沉浸式追漫，加载速度快、画质高清，为你打造流畅不卡顿的在线看漫画体验。
              每日同步更新热门连载，免费漫画全集随心畅读。
            </p>

            <div className="flex flex-wrap gap-6 justify-center lg:justify-start mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400">20000+</div>
                <div className="text-xs text-background-50/60 mt-1">漫画资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">每日更新</div>
                <div className="text-xs text-background-50/60 mt-1">同步连载</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-400">高清画质</div>
                <div className="text-xs text-background-50/60 mt-1">流畅阅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                开始阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
              >
                人气排行
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center mt-8 lg:mt-0">
            <div className="relative w-full max-w-xs sm:max-w-sm lg:max-w-md">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden border-2 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Beautiful%20stylized%20digital%20manga%20artwork%20featuring%20an%20elegant%20character%20portrait%20with%20flowing%20hair%20and%20expressive%20eyes%20in%20modern%20Korean%20webtoon%20style%2C%20surrounded%20by%20soft%20ethereal%20cherry%20blossom%20petals%20and%20delicate%20sparkles%2C%20warm%20romantic%20color%20palette%20with%20coral%20pink%20and%20cream%20tones%2C%20dreamy%20atmospheric%20background%20with%20bokeh%20lights%2C%20editorial%20quality%20illustration%20with%20rich%20details%20and%20soft%20gradients&width=800&height=1000&seq=hero-visual-manga&orientation=portrait"
                  alt="汗汗漫画精选漫画角色"
                  title="汗汗漫画精选漫画"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl overflow-hidden border-2 border-background-50/20 rotate-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Cute%20chibi%20style%20manga%20character%20winking%20happily%20holding%20a%20comic%20book%2C%20colorful%20pastel%20background%20with%20stars%20and%20hearts%2C%20kawaii%20Japanese%20anime%20art%20style%2C%20bright%20cheerful%20colors%2C%20simple%20clean%20illustration&width=400&height=400&seq=hero-badge-manga&orientation=squarish"
                  alt="每日更新"
                  title="汗汗漫画每日更新"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}